// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"4db4fe34","154":"01baada2","201":"2bcd5d49","349":"497cbc28","453":"258b012d","537":"7cd6a848","612":"302bc57d","644":"1ced940c","651":"ceec25e3","841":"0a77a21d","885":"65a1e923","936":"ec467d21","960":"31dad161","992":"594be253"}[chunkId] + ".chunk.js";
};